import { useState, useEffect } from 'react';
import { AspectRatio, Button, Card, CardContent, Typography, CircularProgress } from '@mui/joy';
import Fancybox from './Fancybox';
import { useCurrentTheme } from '../hooks/useCurrentTheme';

function Image({ image, name, token }) {
    const fileID = image ? image[0]?.сжатое_фото_file_id ?? null : null;

    const [imageSrc, setImageSrc] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const theme = useCurrentTheme();

    useEffect(() => {
        if (!fileID) return;

        const fetchImage = async () => {
            try {
                setLoading(true);
                const response = await fetch(`https://api.nmbook.ru/files/${fileID}/content`, {
                    headers: {
                        'Authorization': `Bearer ${token}`
                    }
                });

                if (!response.ok) {
                    throw new Error('Не удалось загрузить изображение');
                }

                const imageBlob = await response.blob();
                const reader = new FileReader();
                reader.onloadend = () => {
                    setImageSrc(reader.result);
                };
                reader.readAsDataURL(imageBlob);
            } catch (err) {
                console.error('Ошибка загрузки изображения:', err);
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        fetchImage();
    }, [fileID, token]);

    if (!fileID || error) {
        return (
            <Fancybox>
                <a data-fancybox="gallery" href="/img/icon.jpg">
                    <AspectRatio minHeight="120px" maxHeight="200px" sx={{ borderRadius: '8px' }}>
                        <img
                            src="/img/icon.jpg"
                            loading="lazy"
                            alt={name}
                            style={{
                                width: '100%',
                                height: '100%',
                                objectFit: 'contain',
                                backgroundColor: theme.card.bgImg,
                                objectPosition: 'center',
                                borderRadius: '8px'
                            }}
                        />
                    </AspectRatio>
                </a>
            </Fancybox >
        );
    }

    if (loading) {
        return (
            <AspectRatio minHeight="120px" maxHeight="200px" sx={{ borderRadius: '8px' }}>
                <div
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        backgroundColor: '#123',
                        borderRadius: '8px',
                        width: '100%',
                        height: '100%'
                    }}
                >
                    <CircularProgress />
                </div>
            </AspectRatio>
        );
    }

    return (
        <Fancybox>
            <a data-fancybox="gallery" href={imageSrc}>
                <AspectRatio minHeight="200px" maxHeight="200px" sx={{ borderRadius: '8px', overflow: 'hidden' }}>
                    <img
                        src={imageSrc}
                        alt={`Фотография новомученика ${name}`}
                        style={{
                            width: '100%',
                            height: '100%',
                            objectFit: 'contain',
                            objectPosition: 'center',
                            background: theme.card.bgImg,
                        }}
                    />
                </AspectRatio>
            </a>
        </Fancybox>
    );
}

function ShowCard({ item, index, token }) {
    const theme = useCurrentTheme()

    return (
        <Card
            className="widget-card"
            sx={{
                backgroundColor: theme.card.bg,
                borderColor: theme.card.border
            }}>
            <div>
                <Typography level="title-lg" sx={{ color: theme.text.title }}>{item?.ФИО ?? '—'}</Typography>
                <Typography level="body-sm" sx={{ color: theme.text.paragraph }}>
                    {item?.Рождение?.год ?? "..."}-{item?.Кончина?.год ?? "..."}, {item?.сан_церк_служение ?? "..."}
                </Typography>
            </div>
            <Image image={item?.Фотографии ?? null} name={item?.ФИО ?? null} token={token} />
            <CardContent orientation="vertical" sx={{ gap: '24px' }}>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                    <div>
                        <Typography level="body-xs" sx={{ color: theme.text.paragraph }}>
                            {item?.Рождение?.текст}
                        </Typography>
                    </div>
                    <div>
                        <Typography level="body-xs" sx={{ color: theme.text.paragraph }}>
                            {item?.Кончина?.текст}
                        </Typography>
                    </div>
                </div>
                <Button
                    component="a"
                    href={`https://widget-info.dybka.ru/?back=true#index-${index + 1}`}
                    variant="solid"
                    size="md"
                    color="primary"
                    aria-label={`Узнать подробнее про новомученника ${item?.ФИО}`}
                    className="button-more"
                >
                    Подробнее
                </Button>
            </CardContent>
        </Card>
    )
}

export default ShowCard;
